export default class Helpers {
	static userAgent: string = window.navigator && window.navigator.userAgent;
	/**
	 * 校验是否为 Chrome 浏览器
	 */
	static checkIsChrome (): boolean {
		return this.userAgent.indexOf('Chrome') > -1;
	}
	/**
	 * 获取 Chrome 版本
	 */
	static getChromeVersion (): number {
		let res: number = -1;
		if (!this.checkIsChrome()) return res;
		const reg = /Chrome\/([0-9]*)/;
		const regRes = reg.exec(this.userAgent);
		if (regRes && regRes[1]) {
			res = Number(regRes[1]);
		}
		return res;
	}
	// 判断设备是否为手机设备
    static checkIsMobile () {
        return /(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i.test(window.navigator.userAgent);
    }
}
